'use client'

import Script from 'next/script'

import { useLocalization } from '../../../_providers/LocalizationProvider.client'

export const DataDomeScript = () => {
  const { languageGroup } = useLocalization()
  const dataDomeClientKey = process.env.NEXT_PUBLIC_DATADOME_CLIENT_KEY
  const apiBaseUrl = process.env.NEXT_PUBLIC_CLIENT_API_BASE_URL

  if (!dataDomeClientKey || !apiBaseUrl) return null

  const apiDomain = apiBaseUrl.replace('https://', '')

  return (
    <>
      <Script
        id='datadome-config-script'
        strategy='beforeInteractive' // DataDome blocks traffic like OneTrust and needs to be before other JS
        dangerouslySetInnerHTML={{
          __html: `
          window.ddjskey = '${dataDomeClientKey}';
          window.ddoptions = {
            endpoint: '${apiBaseUrl}/a/datadome/js/',
            challengeLanguage: '${languageGroup}',
            ajaxListenerPath: [
              { host: '${apiDomain}', path: '/api/*' },
              { host: '${apiDomain}', path: '/*/graphql' }
            ],
            ajaxListenerPathExclusion: [
              { path: '/api/static/*' }
            ]
          };
        `,
        }}
      />
      <Script
        id='datadome-script'
        src={`${apiBaseUrl}/j/datadome/tags.js`}
        strategy='beforeInteractive' // DataDome blocks traffic like OneTrust and needs to be before other JS
      />
    </>
  )
}
